
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Sedancabserviceinpune() {



    const cardData =
    {
        keyword: 'Sedan Cab Service in Pune',
        heading: 'Meghana Cab : Sedan Cab Service in Pune',
        headingDescription: 'Meghana Cab offers reliable Sedan Cab Service in Pune, ideal for city travel, airport transfers, corporate meetings, and outstation trips. Our fleet includes clean, air-conditioned sedans like Dzire, Xcent, and Amaze, driven by courteous and experienced chauffeurs. Whether you are heading to work, a family event, or a weekend getaway, our sedan cabs provide the perfect blend of comfort, affordability, and performance. Enjoy competitive rates, punctual pickups, and 24/7 customer support for a hassle-free ride experience. Book your Sedan Cab in Pune with Meghana Cab and experience smooth, stylish, and secure travel anytime, anywhere',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
   {
    "title": "Osho Ashram (Meditation Resort)",
    "description": "Nestled in lush Koregaon Park, this global meditation centre promotes wellness through guided meditations, yoga, therapies, and silent retreats. Housed in serene halls with beautifully maintained gardens, it provides a space for introspection and rejuvenation." 
  },
    {
    "title": "Sinhagad Fort",
    "description": "Perched at 1,317 m on the Sahyadri range, this ancient hill fortress—famed for the 1670 Battle of Sinhagad—offers rugged treks, two main gateways (Pune & Kalyan Darwaza), Tanaji Malusare’s memorial, and sweeping vistas of the Deccan Plateau. It’s a beloved weekend trek with food stalls serving local fare." 
  },
    {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Maratha Peshwas, this iconic fortification features grand teak gateways, granite walls, ornate fountains, and remnants of its former glory. Despite a destructive fire in 1828, the five surviving gates—like the Delhi and Mastani Darwaza—and the palace ruins offer a journey into Maratha power and intrigue, often brought to life during the evening light-and-sound show." 
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 with Italian arches and set amidst sprawling lawns, this palatial structure served both famine relief and later the Indian freedom struggle—Mahatma Gandhi and his family were interned here. Now a museum, it preserves Gandhi’s personal items and the samadhis of Kasturba Gandhi and Mahadev Desai, echoing India’s fight for independence." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century monolithic rock‑cut Shiva temple carved from basalt, this subterranean sanctum includes a circular Nandi mandapa with intricately carved pillars and a unique ‘underworld’ symbolism, all nestled within a peaceful urban heritage setting." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most celebrated sacred sites, this temple houses a lavishly adorned gold Ganesh idol and draws devotees year‑round. During Ganesh Chaturthi, its vibrant rituals, processions, and communal spirit make it a cultural highlight." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second‑highest hill at ~2,100 ft, crowned by the historic Peshwa-era Parvati Temple. A 103-step climb rewards visitors with rooftop city views, a small museum, and serene gardens—popular at sunrise and for spiritual solace." 
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Housing 20,000+ artifacts—ranging from decorative arts to musical instruments—this museum offers a vivid window into daily life in historical India. It recently introduced geofenced multilingual audio guides across its eight galleries. " 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial dedicated to Maratha warrior Mahadji Shinde (d.1794), featuring Rajasthani-style carved pavilions, colored glass windows, and serene courtyards. It marks both his cremation spot and enduring legacy." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning 130 acres at Pune’s edge, this family-friendly park includes a zoo, snake park, aviary, and botanical sections. It combines wildlife conservation with educational exhibits and picnic spaces." 
  }
],

"services": [
  {
    "name": "Sedan Car Hire Pune",
    "description": "Hire a stylish and comfortable sedan car in Pune for any occasion. Whether it’s a business trip, family outing, or casual travel, our sedans offer a smooth ride, professional drivers, and flexible packages tailored to your needs. Enjoy punctual service and well-maintained vehicles for an exceptional travel experience."
  },
  {
    "name": "AC Sedan Taxi Pune",
    "description": "Travel comfortably in air-conditioned sedans across Pune. Our AC sedan taxis are perfect for beating the heat while enjoying a clean, quiet, and relaxing ride. Ideal for airport transfers, local commutes, and outstation trips with reliable drivers dedicated to your safety and convenience."
  },
  {
    "name": "Sedan Cab for Outstation Pune",
    "description": "Planning an outstation trip from Pune? Our sedan cabs provide an affordable yet premium travel option. With experienced drivers, well-maintained vehicles, and flexible booking options, enjoy a hassle-free and comfortable journey no matter the distance."
  },
  {
    "name": "Sedan for Local Travel in Pune",
    "description": "Explore Pune city in style with our local sedan taxi service. Whether for shopping, sightseeing, or daily commutes, our sedans offer prompt pickups, courteous drivers, and a smooth ride to make your local travel convenient and enjoyable."
  },
  {
    "name": "Sedan Cab Pune Airport Transfer",
    "description": "Get timely and stress-free airport transfers in Pune with our dedicated sedan cabs. We track your flight timings, offer meet-and-greet services, and ensure a comfortable ride to or from Pune airport, making your journey seamless and relaxing."
  },
  {
    "name": "Affordable Sedan Taxi in Pune",
    "description": "Experience the perfect blend of comfort and cost-efficiency with our affordable sedan taxis in Pune. Ideal for budget-conscious travelers who want quality service without paying extra, our sedans are clean, reliable, and driven by professional chauffeurs."
  },
  {
    "name": "Online Sedan Booking Pune",
    "description": "Book your sedan cab in Pune online with ease using our secure and user-friendly platform. Choose your preferred vehicle, schedule your trip, and get instant confirmation. Enjoy convenience, transparency, and excellent customer support at every step."
  },
  {
    "name": "Premium Sedan Car Rental Pune",
    "description": "Elevate your travel experience with our premium sedan car rental service in Pune. Our high-end sedans come with luxurious interiors, modern amenities, and experienced chauffeurs to provide you with a classy, comfortable, and safe journey for any occasion."
  },
  {
    "name": "Pune to Mumbai Sedan Cab",
    "description": "Travel between Pune and Mumbai in comfort with our dedicated sedan cab service. Whether for business or leisure, enjoy a smooth ride, punctual pickups, and courteous drivers who ensure a stress-free journey across this popular route."
  },
  {
    "name": "Wedding Sedan Car Hire Pune",
    "description": "Make your special day memorable with our elegant wedding sedan car hire in Pune. We provide beautifully maintained cars, professional chauffeurs, and customizable packages to complement your wedding celebrations with style and comfort."
  },
  {
    "name": "Corporate Sedan Cabs Pune",
    "description": "Impress your clients and employees with our corporate sedan cab services in Pune. We offer professional, punctual, and comfortable travel solutions tailored to business needs, including airport transfers, meetings, and corporate events."
  },
  {
    "name": "Family Sedan Travel Pune",
    "description": "Enjoy a safe and comfortable family trip around Pune with our family-friendly sedan cabs. Spacious interiors, child safety features, and courteous drivers make your family outings pleasant and worry-free."
  },
  {
    "name": "Comfortable Sedan with Driver Pune",
    "description": "Relax and unwind in our comfortable sedan cabs driven by professional chauffeurs in Pune. Whether you need a ride for work, leisure, or errands, our drivers ensure safe, timely, and courteous service throughout your journey."
  },
  {
    "name": "Pune Local Sedan Trips",
    "description": "Discover Pune conveniently with our local sedan trip services. Perfect for sightseeing, shopping, or daily travel, our sedans provide reliable and affordable transportation with experienced drivers familiar with the city’s routes."
  },
  {
    "name": "Chauffeur Driven Sedan Pune",
    "description": "Experience luxury and convenience with our chauffeur-driven sedan service in Pune. Our professional drivers ensure a smooth, personalized journey while you relax and focus on your tasks, meetings, or sightseeing."
  }
],
"tableData": [
  ["Sedan Car Hire Pune", "AC Sedan Taxi Pune"],
  ["Sedan Cab for Outstation Pune", "Sedan for Local Travel in Pune"],
  ["Sedan Cab Pune Airport Transfer", "Affordable Sedan Taxi in Pune"],
  ["Online Sedan Booking Pune", "Premium Sedan Car Rental Pune"],
  ["Pune to Mumbai Sedan Cab", "Wedding Sedan Car Hire Pune"],
  ["Corporate Sedan Cabs Pune", "Family Sedan Travel Pune"],
  ["Comfortable Sedan with Driver Pune", "Pune Local Sedan Trips"],
  ["Chauffeur Driven Sedan Pune", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Premium Sedan Cab Service in Pune",
        "WhyChoosedescription": "Meghana Cab offers top-quality sedan cab services in Pune, providing a perfect blend of comfort, style, and reliability. Our sedans are ideal for business trips, airport transfers, and city tours, ensuring you travel in a sleek, air-conditioned vehicle with spacious seating and smooth rides."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Sedans",
        "WhyChoosedescription": "All our sedans undergo regular maintenance and thorough sanitization to guarantee cleanliness and safety for every passenger. Equipped with modern amenities, our vehicles ensure a pleasant and hygienic travel experience across Pune’s bustling streets."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our skilled drivers are familiar with Pune’s traffic patterns, shortcuts, and key locations. They offer courteous, timely, and safe driving, helping you reach your destination promptly while providing a hassle-free and secure ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive fares for our sedan cabs with no hidden charges. Our pricing includes fuel, taxes, tolls, and driver allowances, so you get full clarity upfront and can choose flexible payment options suited to your travel needs."
    },
    {
        "WhyChooseheading": "Flexible Booking and Ride Options",
        "WhyChoosedescription": "Whether you need a quick city ride, hourly rental, or full-day booking, our sedan cab service offers flexible options to suit your schedule. Customize your trip with pick-up and drop-off locations anywhere in Pune and surrounding areas."
    },
    {
        "WhyChooseheading": "Comfort and Privacy for Business Travelers",
        "WhyChoosedescription": "Our sedan cabs provide a quiet and comfortable environment, perfect for business travelers who wish to work or relax during transit. Enjoy ample legroom, smooth suspension, and privacy throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Book your sedan cab anytime with our round-the-clock customer support. Our friendly team is always available to assist with reservations, modifications, and real-time trip updates to ensure a seamless travel experience."
    },
    {
        "WhyChooseheading": "Ideal for Solo Travelers, Couples, and Small Groups",
        "WhyChoosedescription": "Our sedan cab service is perfect for individuals, couples, or small groups who prefer a comfortable, stylish, and affordable mode of transport in Pune. We prioritize safety, punctuality, and a pleasant ride every time."
    }
]



























    }

const faqData = [
    {
        question: "How can I book a sedan cab service in Pune with Meghana Cab?",
        answer: "You can book your sedan cab in Pune by calling Meghana Cab at +91 9075462128 or through our website for quick and easy booking."
    },
    {
        question: "What types of sedan vehicles are available in Pune?",
        answer: "We offer a variety of comfortable and well-maintained sedan cars like Toyota Etios, Honda Amaze, and Maruti Suzuki Dzire."
    },
    {
        question: "Are Meghana Cab drivers experienced with Pune city routes?",
        answer: "Yes, our drivers are knowledgeable about Pune’s roads and traffic patterns to ensure a smooth ride."
    },
    {
        question: "Is the sedan cab service available for airport transfers and local travel?",
        answer: "Yes, our sedan cabs can be booked for airport pickups, drop-offs, and local city travel within Pune."
    },
    {
        question: "Are fares inclusive of all charges like fuel, tolls, and driver fees?",
        answer: "Our fares include fuel, tolls, and driver charges. Any additional waiting time or parking charges may apply separately."
    },
    {
        question: "Are the sedans sanitized before each trip?",
        answer: "Yes, all our sedan vehicles are thoroughly sanitized before every journey for your safety and hygiene."
    },
    {
        question: "Is the sedan cab service available 24/7 in Pune?",
        answer: "Yes, Meghana Cab operates 24/7 to cater to your travel needs anytime."
    },
    {
        question: "Can I request stops during the ride for meals or sightseeing?",
        answer: "Yes, you can request stops. Please inform us at the time of booking to plan accordingly."
    },
    {
        question: "What payment methods are accepted for sedan cab service in Pune?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How do I contact Meghana Cab to book a sedan cab in Pune?",
        answer: "Call us at +91 9075462128 anytime to book your sedan cab or get assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Anil More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The sedan cab service in Pune by Meghana Cab was excellent — comfortable car and polite driver.”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable and timely sedan service in Pune. Meghana Cab is my go-to for local travel.”',
    },
];











































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const sedanCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Sedan Cab Service in Pune",
  "image": "https://www.meghanacabs.com/assets/images/sedan-cab-pune.jpg",
  "description": "Book premium and affordable sedan cab service in Pune with Meghana Cabs. AC sedans for local travel, airport transfers, corporate rides, weddings, and outstation trips.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "Sedan Car Hire Pune",
    "AC Sedan Taxi Pune",
    "Sedan Cab for Outstation Pune",
    "Sedan for Local Travel in Pune",
    "Sedan Cab Pune Airport Transfer",
    "Affordable Sedan Taxi in Pune",
    "Online Sedan Booking Pune",
    "Premium Sedan Car Rental Pune",
    "Pune to Mumbai Sedan Cab",
    "Wedding Sedan Car Hire Pune",
    "Corporate Sedan Cabs Pune",
    "Family Sedan Travel Pune",
    "Comfortable Sedan with Driver Pune",
    "Pune Local Sedan Trips",
    "Chauffeur Driven Sedan Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Sedan Cab Service in Pune | AC Sedan Taxi & Car Hire | Meghana Cabs</title>
  <meta
    name="description"
    content="Book premium and affordable sedan cab service in Pune with Meghana Cabs. AC sedans for local travel, airport transfers, corporate rides, weddings, and outstation trips."
  />
  <meta
    name="keywords"
    content="Sedan Car Hire Pune, AC Sedan Taxi Pune, Sedan Cab for Outstation Pune, Sedan for Local Travel in Pune, Sedan Cab Pune Airport Transfer, Affordable Sedan Taxi in Pune, Online Sedan Booking Pune, Premium Sedan Car Rental Pune, Pune to Mumbai Sedan Cab, Wedding Sedan Car Hire Pune, Corporate Sedan Cabs Pune, Family Sedan Travel Pune, Comfortable Sedan with Driver Pune, Pune Local Sedan Trips, Chauffeur Driven Sedan Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(sedanCabServiceSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Sedancabserviceinpune;